import { LOGIN_HOST } from '../const';
import defaultStrategy from './default-login';
import { isHigherThan } from '../../version';

const location = window.location;

export default {
  name: 'zuzuche',
  isLogin: defaultStrategy.isLogin,
  gotoLogin() {
    const zzc = window.zzc;
    if (zzc) {
      let loginUrl = `${
        location.protocol
      }//${LOGIN_HOST}/account/login.php?goback=1`;
      loginUrl = `${loginUrl}&ref=${location.href}`;
      // 5.3.49 之后使用新的登录
      const url = isHigherThan('5.3.49') ? '/login/v2/' : '/login/';
      return zzc.call('page_linkTo', {
        url: url.concat(`?sourceUrl=${encodeURIComponent(loginUrl)}`),
        success(response) { console.log(response); }
      });
    }
    return defaultStrategy.gotoLogin();
  },
  clearLogin: defaultStrategy.clearLogin
};
